/* ==========================================================================
   NaturoTheke — Hauptmenue: Aufklappen beim Darueberfahren

   Dawn oeffnet die Unterpunkte erst beim KLICK auf den Hauptpunkt (natives
   <details>). Weil der Klick jetzt auf die Kategorieseite fuehrt, braucht das
   Aufklappen einen anderen Ausloeser — sonst kaeme man am Computer nicht mehr
   an die Unterpunkte.

   Nur dort, wo es eine echte Maus gibt. Auf Touch-Geraeten waere "Hover" ein
   Tippen und wuerde mit dem Link kollidieren; dort fuehrt der Tipp zur Seite,
   und im Handy-Menue steht zusaetzlich "Alle anzeigen".
   ========================================================================== */

(function () {
  'use strict';

  var MAUS = window.matchMedia('(hover: hover) and (min-width: 990px)');
  // Kurze Nachlaufzeit beim Verlassen: sonst klappt das Menue schon zu, wenn
  // die Maus die Luecke zwischen Beschriftung und Liste kreuzt.
  var NACHLAUF = 140;

  function einrichten() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
      if (menu.dataset.naturoHover === 'an') return;

      var details = menu.querySelector('details');
      if (!details) return;
      menu.dataset.naturoHover = 'an';

      var timer;

      menu.addEventListener('mouseenter', function () {
        if (!MAUS.matches) return;
        clearTimeout(timer);
        details.open = true;
      });

      menu.addEventListener('mouseleave', function () {
        if (!MAUS.matches) return;
        timer = setTimeout(function () {
          details.open = false;
        }, NACHLAUF);
      });

      // Beim Klick auf den Hauptpunkt laedt die Kategorieseite. Das offene
      // Menue soll dabei nicht stehen bleiben.
      var parent = menu.querySelector('.naturo-menu__parent');
      if (parent) {
        parent.addEventListener('click', function () {
          clearTimeout(timer);
          details.open = false;
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }
})();
